import { Modal as ModalDS } from '@dasa-health/components-react'
import styled from 'styled-components'
import CustomTheme from 'theme'

export const Modal = styled(ModalDS)`
    &&& {
        padding: 24px 32px 32px;
        text-align: left;
        flex-direction: column;

        width: auto;
        max-width: 90%;
        margin: 0 auto;
        border-radius: 8px;
        height: auto;

        ${CustomTheme.breakPoint.tablet} {
            width: 550px;
            max-width: none;
        }

        > span {
            position: static;
            line-height: 1;
            align-self: flex-end;
        }
    }
`

export const ModalWrapper = styled.div`
    flex: 1 0;
    width: 100%;
    padding: 1rem 0 0;
    * > {
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    }
`

export const ModalTitle = styled.h1`
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 2rem;
    letter-spacing: 0;
    text-align: center;
    color: #161616;
    margin-bottom: 0.5rem;

    ${CustomTheme.breakPoint.tablet} {
        text-align: left;
    }
`

export const ModalContent = styled.div`
    p,
    li {
        color: #666;
        line-height: 1.5rem;
        margin-bottom: 1.5rem;
        font-size: 0.875rem;
    }

    ul {
        margin-left: 1.25rem;
        li {
            list-style-type: disc;
            margin: 0;
        }
    }

    h2 {
        color: #161616;
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.5rem;
        margin-bottom: 0.5rem;
    }
`
export const ModalFooter = styled.div`
    margin-top: 1.5rem;
`
